export enum GridColumnEvent {
  SortChanged = 'sortChanged',
}
